export function normalizeProducer(input) {
  if (input == null) return undefined;

  if (typeof input === "string" && input.trim().length > 0) return input;

  if (typeof input === "number" && Number.isFinite(input)) return String(input);

  if (typeof input === "object") {
    const anyObj = input;
    const v = anyObj.value ?? anyObj.id;
    if (typeof v === "string" && v.trim().length > 0) return v;
    if (typeof v === "number" && Number.isFinite(v)) return String(v);
  }

  return undefined;
}
